<template lang="pug">
.send-request-rplies-tab
  .mb-3

  //- 受け入れ可
  b-card.mb-2(no-body v-if="_replyAcceptance == true")
    b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle="'accordion-possible'")
      .toggle-text.pl-2 受け入れ可（{{ replies.possibleItems.length }}件）
    b-collapse(id="accordion-possible" accordion="accordion-possible" role="tabpanel")
      b-card-body.p-1
        .item-row.d-flex.flex-row.align-items-start.mb-1(v-for="(item, index) in replies.possibleItems")
          SendRequestReplyFacility.mr-4(v-model="item.facility" style="width:50%;")
          SendRequestReplyMessage(v-model="replies.possibleItems[index]" style="width:50%;")

  //- 詳細確認希望
  b-card.mb-2(no-body v-if="_replyAcceptance == true")
    b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle="'accordion-need-consultation'")
      .toggle-text.pl-2 詳細確認希望（{{ replies.needConsultationItems.length }}件）
    b-collapse(id="accordion-need-consultation" accordion="accordion-need-consultation" role="tabpanel")
      b-card-body.p-1
        .item-row.d-flex.flex-row.align-items-start.mb-1(v-for="(item, index) in replies.needConsultationItems")
          SendRequestReplyFacility.mr-4(v-model="item.facility" style="width:50%;")
          SendRequestReplyMessage(v-model="replies.needConsultationItems[index]" style="width:50%;")

  //- 受け入れ不可
  b-card.mb-2(no-body v-if="_replyAcceptance == true")
    b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle="'accordion-not-possible'")
      .toggle-text.pl-2 受け入れ不可（{{ replies.notPossibleItems.length }}件）
    b-collapse(id="accordion-not-possible" accordion="accordion-not-possible" role="tabpanel")
      b-card-body.p-1
        .item-row.d-flex.flex-row.align-items-start.mb-1(v-for="(item, index) in replies.notPossibleItems")
          SendRequestReplyFacility.mr-4(v-model="item.facility" style="width:50%;")
          SendRequestReplyMessage(v-model="replies.notPossibleItems[index]" style="width:50%;")

  //- 返信済
  b-card.mb-2(no-body v-if="_replyAcceptance == false")
    b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle="'accordion-reply'")
      .toggle-text.pl-2 返信済（{{ replies.replyItems.length }}件）
    b-collapse(id="accordion-reply" accordion="accordion-reply" role="tabpanel")
      b-card-body.p-1
        .item-row.d-flex.flex-row.align-items-start.mb-1(v-for="(item, index) in replies.replyItems")
          SendRequestReplyFacility.mr-4(v-model="item.facility" style="width:50%;")
          SendRequestReplyMessage(v-model="replies.replyItems[index]" style="width:50%;")

  //- 未返信
  b-card.mb-2(no-body)
    b-card-header(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle="'accordion-no-reply'")
      .toggle-text.pl-2 未返信（{{ replies.noReplyItems.length }}件）
    b-collapse(id="accordion-no-reply" accordion="accordion-no-reply" role="tabpanel")
      b-card-body.p-1
        .item-row.d-flex.flex-row.align-items-start.mb-1(v-for="(item, index) in replies.noReplyItems")
          SendRequestReplyFacility.mr-4(v-model="item.facility" style="width:50%;")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { OtherOfficeAcceptanceRequestsGetModel } from "@/commons/services/OtherOfficeAcceptanceRequests";
import { OtherOfficeAcceptanceRequestRepliesGetModel } from "@/commons/services/OtherOfficeAcceptanceRequestReplies";

import SendRequestReplyFacility from "@/pc/components/otherOfficeRoomSchedules/SendRequestReplyFacility.vue";
import SendRequestReplyMessage from "@/pc/components/otherOfficeRoomSchedules/SendRequestReplyMessage.vue";

/**
 * ### 送信タブコンポーネント
 */
@Component({
  components: {
    SendRequestReplyFacility,
    SendRequestReplyMessage
  }
})
export default class SendRequestRepliesTab extends Vue {
  @Prop()
  request!: OtherOfficeAcceptanceRequestsGetModel;
  /** リクエスト返信（受け入れ可、詳細確認希望、受け入れ不可、返信済み、未返信に分ける） */
  @Prop()
  replies!: SendRequestRepliesModel;

  get _replyAcceptance(): boolean {
    if (!this.request) {
      return false;
    }
    return this.request.replyAcceptance;
  }
}

export interface SendRequestRepliesModel {
  /** 受け入れ可 */
  possibleItems: Array<OtherOfficeAcceptanceRequestRepliesGetModel>;
  /** 詳細確認希望 */
  needConsultationItems: Array<OtherOfficeAcceptanceRequestRepliesGetModel>;
  /** 受け入れ不可 */
  notPossibleItems: Array<OtherOfficeAcceptanceRequestRepliesGetModel>;
  /** 返信済 */
  replyItems: Array<OtherOfficeAcceptanceRequestRepliesGetModel>;
  /** 未返信 */
  noReplyItems: Array<OtherOfficeAcceptanceRequestRepliesGetModel>;
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.item-row {
  padding: 0.5rem;
  border: 1px solid $border-lightgray;
}
</style>
